<template>
  <div id="areaBar"></div>
</template>
<script>
export default {
  name: "ChartAreaBar",
  props: ["templeDate"],
  computed: {
    areaData() {
      return [
        {
          // 亚洲
          groupId: this.$t("chart.asia"),
          value: 0,
        },
        {
          // 北美洲
          groupId: this.$t("chart.northAmerica"),
          value: 0,
        },
        {
          // 南美洲
          groupId: this.$t("chart.southAmerica"),
          value: 0,
        },
        {
          // 大洋洲
          groupId: this.$t("chart.oceania"),
          value: 0,
        },
        {
          // 欧洲
          groupId: this.$t("chart.europe"),
          value: 0,
        },
        {
          // 非洲
          groupId: this.$t("chart.africa"),
          value: 0,
        },
        {
          // 南极洲
          groupId: this.$t("chart.antarctica"),
          value: 0,
        },
      ];
    },

    xData() {
      return [
        // 亚洲
        this.$t("chart.asia"),
        this.$t("chart.northAmerica"),
        // 南美洲
        this.$t("chart.southAmerica"),
        this.$t("chart.oceania"),
        // 欧洲
        this.$t("chart.europe"),
        this.$t("chart.africa"),
        this.$t("chart.antarctica"),
      ];
    },
  },
  data() {
    return {
      listLoading: true,
      //区域分类
      clickArea: "continent",
    };
  },
  watch: {
    templeDate: {
      deep: true,
      handler(newVal, oldVal) {
        this.dynasty = newVal;
      },
    },
  },
  created() {},
  mounted() {
    this.$nextTick(() => {
      this.getAreaData();
    });
  },
  methods: {
    // 按区域分布
    getAreaData() {
      let pardata = { type: "continent", value: "", valueType: "" };
      this.$Loading.show();
      this.http.From("temple/getTempleListByType", pardata).then((res) => {
        this.$Loading.hide();
        if (res.code == "0") {
          for (let i = 0; i < res.data.length; i++) {
            switch (res.data[i].groupId) {
              case "亚洲":
                this.areaData[0].value = res.data[i].value;
                break;
              case "北美洲":
                this.areaData[1].value = res.data[i].value;
                break;
              case "南美洲":
                this.areaData[2].value = res.data[i].value;
                break;
              case "大洋洲":
                this.areaData[3].value = res.data[i].value;
                break;
              case "欧洲":
                this.areaData[4].value = res.data[i].value;
                break;
              case "非洲":
                this.areaData[5].value = res.data[i].value;
                break;
              case "南极洲":
                this.areaData[6].value = res.data[i].value;
                break;
            }
          }
          this.getAreaBAR();
        } else {
          this.$message.error(res.message);
        }
      });
    },

    // 按区域分布
    getAreaBAR() {
      let that = this;
      let areaBar = this.$echarts.init(document.getElementById("areaBar"));
      let areaData = [];
      for (let i = 0; i < this.areaData.length; i++) {
        areaData.push(this.areaData[i].value);
      }
      // //x轴
      // const xData = [
      //   that.areaData[0].groupId,
      //   that.areaData[1].groupId,
      //   that.areaData[2].groupId,
      //   that.areaData[3].groupId,
      //   that.areaData[4].groupId,
      //   that.areaData[5].groupId,
      //   that.areaData[6].groupId,
      // ];

      //定义数据间隔
      const dataInterval = [0, 5, 10, 100, 500, 1000, 2000, 5000];
      const areaData2 = [];
      for (var i = 0; i < areaData.length; i++) {
        // 1.寻找在数据间隔里小于areaData的最大值
        const min_v = Math.max(...dataInterval.filter((v) => v <= areaData[i]));
        // 2.寻找在数据间隔里大于areaData的最小值
        const max_v = Math.min(...dataInterval.filter((v) => v > areaData[i]));
        //  3.寻找 min_v 所在的下标
        const index = dataInterval.findIndex((v) => v === min_v);
        //  4.计算该amount在y轴上应该展示的位置
        const y_value =
          ((areaData[i] - min_v) / (max_v - min_v)) * 10 + index * 10;
        areaData2[i] = y_value;
      }

      let option;
      option = {
        title: {
          // 妈祖庙世界分布柱状图
          text: that.$t("chart.t2"),
          // 点击柱状图查看详细区域分布
          subtext: that.$t("chart.t3"),
        },
        color: "#f14d2b",
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
          },
          formatter: (v) => {
            //界面显示原数值
            return `<div>
                      <div>${that.xData[v[0].dataIndex]}</div>
                      <div> ${that.$t("chart.num")}：${
              areaData[v[0].dataIndex]
            }</div>
                   </div>`;
          },
        },
        xAxis: [
          {
            type: "category",
            data: that.xData,
            axisTick: {
              alignWithLabel: true,
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            axisLabel: {
              formatter: (v, i) => {
                if (i === 0) {
                  v = "0";
                }
                if (i === 1) {
                  v = "5";
                }
                if (i === 2) {
                  v = "10";
                }
                if (i === 3) {
                  v = "100";
                }
                if (i === 4) {
                  v = "500";
                }
                if (i === 5) {
                  v = "1000";
                }
                if (i === 6) {
                  v = "2000";
                }
                if (i === 7) {
                  v = "5000";
                }
                return v;
              },
            },
          },
        ],
        dataGroupId: "",
        animationDurationUpdate: 500,
        series: {
          name: that.$t("chart.num"),
          type: "bar",
          showBackground: true,
          id: "sales",
          // label: {
          //   normal: {
          //     show: true,
          //     position: "top",
          //     formatter: function (v) {
          //       var val = v.value;
          //       return val;
          //     },
          //     color: "#f14d2b",
          //   },
          // },
          data: areaData2,
          universalTransition: {
            enabled: true,
            divideShape: "clone",
          },
          itemStyle: {
            // color: new that.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
            //   { offset: 0, color: "#f9b8aa" },
            //   { offset: 0.5, color: "#f2684b" },
            //   { offset: 1, color: "#f04d2b" },
            // ]),
            color: "rgb(90, 177, 239)",
          },
        },
        graphic: [
          {
            type: "text",
            right: 50,
            top: 20,
            style: {
              text: "",
              fontSize: 16,
            },
          },
        ],
        animationDuration: 3000,
      };
      // areaBar.getZr().on("click", function (params) {
      //   console.log(params);
      // });
      areaBar.on("click", function (event) {
        if (event.data) {
          let pardata = {};
          if (that.clickArea == "continent") {
            pardata = {
              type: "country",
              value: event.name,
              valueType: "continent",
            };
            that.clickArea = "country";
          } else if (that.clickArea == "country") {
            pardata = {
              type: "province",
              value: event.name,
              valueType: "country",
            };
            that.clickArea = "";
          } else {
            return;
          }
          that.$Loading.show();
          that.http.From("temple/getTempleListByType", pardata).then((res) => {
            that.$Loading.hide();
            if (res.code == "0") {
              let drilldownData = res.data;
              console.log(res.data);
              if (drilldownData[0].value != 0) {
                areaBar.setOption({
                  xAxis: {
                    data: drilldownData.map(function (item) {
                      return item.groupId;
                    }),
                  },

                  yAxis: [
                    {
                      type: "value",
                      axisLabel: {
                        formatter: function (value, index) {
                          return value;
                        },
                      },
                    },
                  ],
                  tooltip: {
                    trigger: "axis",
                    axisPointer: {
                      // 坐标轴指示器，坐标轴触发有效
                      type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
                    },
                    formatter: (v) => {
                      return `<div>
                      <div>${v[0].name}</div>
                      <div> 数量：${v[0].value}</div>
                   </div>`;
                    },
                  },
                  series: {
                    type: "bar",
                    id: "sales",
                    showBackground: true,
                    dataGroupId: event.data.groupId,
                    data: drilldownData,
                    universalTransition: {
                      enabled: true,
                      divideShape: "clone",
                    },
                    // label: {
                    //   normal: {
                    //     show: true,
                    //     position: "top",
                    //     formatter: function (v) {
                    //       var val = v.value;
                    //       return val;
                    //     },
                    //     color: "#f14d2b",
                    //   },
                    // },
                  },
                  graphic: [
                    {
                      type: "text",
                      right: 50,
                      top: 20,
                      style: {
                        text: "返回",
                        fontSize: 16,
                      },
                      onclick: function () {
                        that.clickArea = "continent";
                        areaBar.setOption(option);
                      },
                    },
                  ],
                });
              }
            } else {
              that.$message.error(res.message);
            }
          });
        }
      });
      option && areaBar.setOption(option);
      // 响应布局
      window.addEventListener("resize", () => {
        areaBar.resize();
      });
    },
  },
  beforeDestroy() {
    // this.chart.dispose()
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/_common.scss";
.chart_box {
  .chart_card {
    height: 25rem;
    width: 100%;
    border-radius: $r-big;
    box-shadow: $shadow;
    margin: $m-lit auto;
    padding: $m-lit;
    padding-top: $m-mid;
    background-color: $c-white;
  }
}
</style>
